import AsyncDialog from "./asyncDialog";

export const PROMPTBOX_TYPE_YESNO = 'yesno';
export const PROMPTBOX_TYPE_YESNOCANCEL = 'yesnocancel';
export const PROMPTBOX_TYPE_OKCANCEL = 'okcancel';
export const PROMPTBOX_TYPE_OK = 'ok';

export const PROMPTBOX_RESULT_YES = true;
export const PROMPTBOX_RESULT_NO = false;
export const PROMPTBOX_RESULT_OK = true;
export const PROMPTBOX_RESULT_CANCEL = null;

function appendButtons(target, buttons) {
    buttons.forEach(function (button) {
        target.append(AsyncDialog.makeButton(button.text, button.result));
    });
}

function buttonDef(text, result) {
    return { text: text, result: result };
}

function getButtons(type, yesText, noText, okText, cancelText) {
    switch (type.toLowerCase()) {
        case PROMPTBOX_TYPE_YESNO:
            return [
                buttonDef(yesText, PROMPTBOX_RESULT_YES),
                buttonDef(noText, PROMPTBOX_RESULT_NO)
            ];

        case PROMPTBOX_TYPE_YESNOCANCEL:
            return [
                buttonDef(yesText, PROMPTBOX_RESULT_YES),
                buttonDef(noText, PROMPTBOX_RESULT_NO),
                buttonDef(cancelText, PROMPTBOX_RESULT_CANCEL)
            ];

        case PROMPTBOX_TYPE_OKCANCEL:
            return [
                buttonDef(okText, PROMPTBOX_RESULT_OK),
                buttonDef(cancelText, PROMPTBOX_RESULT_CANCEL)
            ];
        case PROMPTBOX_TYPE_OK:
            return [
                buttonDef(okText, PROMPTBOX_RESULT_OK)
            ];

        default:
            throw new Error(
                String.format(
                    "Invalid type value: {0}. Allowed values are: {1}, {2}, {3} {4}. If not specified, defaults to {1}.",
                    type,
                    PROMPTBOX_TYPE_YESNO,
                    PROMPTBOX_TYPE_YESNOCANCEL,
                    PROMPTBOX_TYPE_OKCANCEL,
                    PROMPTBOX_TYPE_OK,
                ),
            );
    }
}

function makeUi(dialog, title, text, textIsHtml, type, yesText, noText, okText, cancelText) {
    var textContainer = $('<p>');
    var btnContainer = $("<div class='buttons'>");

    var msgDiv = $("<div>")
        .attr("title", title)
        .append(textContainer)
        .append(btnContainer)
        .on("click", "input", function (e) {
            dialog.closeWithResult($(e.target).data("result"));
        });

    if (textIsHtml) {
        textContainer.html(text);
    } else {
        textContainer.addClass('plain-text')
            .text(text);
    }

    appendButtons(btnContainer, getButtons(type, yesText, noText, okText, cancelText));

    return msgDiv;
}

const promptBox = (options) => {
    let dialog = new AsyncDialog();

    dialog.class = 'fv-qRules-prompt-dialog';
    dialog.setTarget(makeUi(
        dialog,
        options.title || "\u00A0",  // nbsp
        options.text || '',
        options.textIsHtml || false,
        options.type || PROMPTBOX_TYPE_YESNO,
        options.yesText || 'Yes',
        options.noText || 'No',
        options.okText || 'OK',
        options.cancelText || 'Cancel'
    ));

    return dialog;
};

export const showPromptBox = (options) => promptBox(options).showAsync();

export default promptBox;